export default function NaiveHeap() {
  const idQ = []
  const dataQ = []
  const readyQ = []

  const naiveHeap = {
    ids,
    dataset,
    has,
    stay,
    kick,
    ready,
    isNextReady,
    next,
    size,
    readySize,
    notReadySize
  }

  return naiveHeap

  function ids() {
    return idQ.concat()
  }

  function dataset() {
    return dataQ.concat()
  }

  function has(id) {
    return idQ.indexOf(id) !== -1
  }

  function stay(id) {
    idQ.push(id)
    dataQ.push(null)
    readyQ.push(false)
    return naiveHeap
  }

  function ready(id, data) {
    const index = idQ.indexOf(id)
    if (index !== -1) {
      dataQ[index] = data
      readyQ[index] = true
    }
    return naiveHeap
  }

  function next() {
    for (let index = 0, length = readyQ.length; index !== length; index++) {
      const ready = readyQ[index]
      if (ready) {
        const data = dataQ[index]
        idQ.splice(index, 1)
        dataQ.splice(index, 1)
        readyQ.splice(index, 1)
        return data
      }
    }
  }

  function isNextReady() {
    for (let index = 0, length = readyQ.length; index !== length; index++) {
      const ready = readyQ[index]
      if (ready) {
        return true
      }
    }
    return false
  }

  function kick(id) {
    const index = idQ.indexOf(id)
    if (index !== -1) {
      idQ.splice(index, 1)
      dataQ.splice(index, 1)
      readyQ.splice(index, 1)
    }
    return naiveHeap
  }

  function size() {
    return idQ.length
  }

  function readySize() {
    return readyQ.filter((ready) => ready).length
  }

  function notReadySize() {
    return readyQ.filter((ready) => !ready).length
  }
}
